var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waste-type-detail" },
    [
      !_vm.activeWasteType && !_vm.activeContent ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _vm.activeWasteType && _vm.activeWasteStream && !_vm.isWasteStream
        ? _c("div", [
            _c("h3", { staticClass: "u-txt-c" }, [
              _vm._v(
                _vm._s(_vm.activeSynonym) +
                  " bij: " +
                  _vm._s(_vm.activeWasteStream.name)
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.activeContent
        ? _c(
            "div",
            [
              _c("div", { staticClass: "waste-type-detail__intro u-p" }, [
                _vm.activeSynonym
                  ? _c("p", [
                      _vm._v("\n        Het afval "),
                      _c("b", [_vm._v(_vm._s(_vm.activeSynonym))]),
                      _vm._v(
                        " hoort bij " +
                          _vm._s(_vm.activeContent.name) +
                          " en valt onder "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.activeWasteStream.name))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.activeContent.intro) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "u-txt-r" }, [
                  _vm.activeContent.recycleLink
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-arrowed",
                          attrs: { href: _vm.activeContent.recycleLink }
                        },
                        [
                          _vm._v("\n          Recycleplein "),
                          _c("i", {
                            staticClass: "fa fa-chevron-right u-float-right"
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeContent.containersLink
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-arrowed",
                          attrs: { href: _vm.activeContent.containersLink }
                        },
                        [
                          _vm._v("\n          Locaties containers"),
                          _c("i", {
                            staticClass: "fa fa-chevron-right u-float-right"
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeContent.bestTasLink
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-arrowed",
                          attrs: { href: _vm.activeContent.bestTasLink }
                        },
                        [
                          _vm._v("\n          BEST-tas "),
                          _c("i", {
                            staticClass: "fa fa-chevron-right u-float-right"
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeContent.KCALink
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-arrowed",
                          attrs: { href: _vm.activeContent.KCALink }
                        },
                        [
                          _vm._v("\n          Chemokar "),
                          _c("i", {
                            staticClass: "fa fa-chevron-right u-float-right"
                          })
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.showRules ||
              _vm.showTips ||
              _vm.showAllowedItems ||
              _vm.showDisallowedItems
                ? _c(
                    "ElCollapse",
                    { attrs: { accordion: "" } },
                    [
                      _vm.showRules
                        ? _c(
                            "ElCollapseItem",
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  { staticClass: "waste-type-detail__heading" },
                                  [_vm._v("Spelregels")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "u-p u-pl-10 u-pb-0" }, [
                                _c(
                                  "ul",
                                  _vm._l(_vm.activeContent.rules, function(
                                    rule,
                                    index
                                  ) {
                                    return _c("li", { key: index }, [
                                      _c("span", [
                                        _vm._v(_vm._s(rule.description))
                                      ])
                                    ])
                                  }),
                                  0
                                )
                              ])
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTips
                        ? _c(
                            "ElCollapseItem",
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  { staticClass: "waste-type-detail__heading" },
                                  [_vm._v("Tips")]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.activeContent.tips, function(
                                tip,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "u-pl-10" },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-info-circle u-mr-10"
                                    }),
                                    _vm._v(
                                      _vm._s(tip.description) + "\n        "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showAllowedItems
                        ? _c(
                            "ElCollapseItem",
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  { staticClass: "waste-type-detail__heading" },
                                  [
                                    _vm._v(
                                      "Wat hoort bij " +
                                        _vm._s(_vm.activeContent.name)
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.allowedItems, function(
                                allowedItem,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "u-pl-10" },
                                  [
                                    allowedItem.length > 0
                                      ? _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-check-circle u-color-success u-mr-10"
                                          }),
                                          _vm._v(_vm._s(allowedItem))
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDisallowedItems
                        ? _c(
                            "ElCollapseItem",
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  { staticClass: "waste-type-detail__heading" },
                                  [
                                    _vm._v(
                                      "Wat hoort er niet bij " +
                                        _vm._s(_vm.activeContent.name)
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.disallowedItems, function(
                                disallowedItem,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "u-pl-10" },
                                  [
                                    disallowedItem.length > 0
                                      ? _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-times-circle u-color-danger u-mr-10"
                                          }),
                                          _vm._v(_vm._s(disallowedItem))
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }